import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { Grid, Box, Typography, Modal } from "@mui/material";
import {
  MediaPlayer,
  type MediaPlayerInstance,
  MediaProvider,
  Poster,
} from "@vidstack/react";
import {
  defaultLayoutIcons,
  DefaultVideoLayout,
} from "@vidstack/react/player/layouts/default";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useCart } from "../../../hooks/shareContext";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../../styles/userPanel.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { axiosInstance } from "../../../utils/tokenSetCookie";
import { useTranslation } from "react-i18next";
// Define prop types
import { debounce } from "lodash"; // Import lodash debounce
import "./VideoPlayer.css"; // Ensure the correct path
import LoginRestriction from "../../../utils/loginRestriction";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import QualitySelector from "../../../utils/videoQualitySelect";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
const VIDEO_BASE_URL = import.meta.env.VITE_VIDEO_BASE_URL;

interface TabContentProps {
  animationList: AnimationList[];
  viewType: "display" | "grid";
  playing: boolean;
  actIndex: number;
}
// animation video type

type animationVideo = {
  animationId: number;
  animationTagName: string;
  bannerUrl: string;
  homepageOrder: number;
  videoUrl: string;
};

type AnimationContent = {
  animationId: number;
  introductionTagName: string;
  conditionTagName: string;
  symptomsTagName: string;
  actionTagName: string;
};

type AnimationList = {
  animationId: number;
  animationTagName: string;
  bannerUrl: string;
  homepageOrder: number;
  videoUrl: string;
  systemNumber: number;
};

const HomepageAnimation: React.FC<TabContentProps> = ({
  animationList,
  viewType,
  playing,
  actIndex,
}) => {
  const { t } = useTranslation();

  const {

    activeAnim,
    setActiveAnim,
    setActiveAnimIndex,
    isSystemNumber,
    isAnimationId,
    setAnimationId,
  } = useCart();
  const [isOpenModal, isSetOpenModal] = useState(false);
  const [_selectVideo, isSetSelectVideo] = useState(0);
  const boxRef = useRef<HTMLDivElement | null>(null);
  const [isActive, setIsActive] = useState(activeAnim);
  const [isAnimationVideo, setIsAnimationVideo] =
    useState<animationVideo | null>(null);

  const [isAnimContent, setIsAnimContent] = useState<AnimationContent | null>(
    null
  );
  const [mouseHover, setMouseHover] = useState(false);

  // const [globalQuality, setGlobalQuality] = useState("auto"); // Store selected quality globally
  const [_showButton, setShowButton] = useState(true);
  const [videoIsPlay, setVideoIsPlay] = useState(false);

  const [videoSize, setVideoSize] = useState({ width: 0, height: 0 });
  const [controlsVisible, setControlsVisible] = useState(false);
  const [_sliderValue, setSliderValue] = useState(100); // Initial Slider Value

  // Sort animationList in ascending order based on translated animationTagName
  const sortedAnimationList = [...animationList].sort((a, b) =>
    t(a.animationTagName).localeCompare(t(b.animationTagName))
  );

  const [isRestrictionOpen, setIsRestrictionOpen] = useState(false);


  const hasPlayedOnce = useRef(false);
  const currentVideoId = useRef<string | null>(null);

  // Create a modified version excluding PIP and Cast
  const customLayoutIcons = {
    ...defaultLayoutIcons,
    pip: undefined,
    chromecast: undefined,
    airplay: undefined, // Optional: remove AirPlay if you want
  };

  //typescript
  setMouseHover;
  setSliderValue;

  useEffect(() => {
    if (!mouseHover && videoIsPlay === true) {
      setShowButton(true);
      const timer = setTimeout(() => {
        setShowButton(false);
      }, 1500); // Disappear after 2 seconds

      return () => clearTimeout(timer); // Cleanup timeout if hover state changes
    } else {
      setShowButton(true); // Reset button when mouse re-enters
    }
  }, [mouseHover]);


  // Custom Next Arrow
  const NextArrow = ({ onClick }: { onClick?: () => void }) => (
    <Box
      onClick={onClick}
      sx={{
        position: "absolute",
        top: "50%",
        right: "-40px",
        transform: "translateY(-50%)",
        width: "25px",
        height: { xs: "50px", sm: "80px", md: "110px", lg: "115", xl: "120px" }, // Responsive height for mobile, tablet, and desktop
        backgroundColor: "#1976d2",
        borderRadius: "10px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        zIndex: 10,
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.8)",
        },
      }}
    >
      <ArrowForwardIosIcon
        sx={{ color: "#fff", fontSize: "18px", marginLeft: "0px" }}
      />
    </Box>
  );

  // Custom Previous Arrow
  const PrevArrow = ({ onClick }: { onClick?: () => void }) => (
    <Box
      onClick={onClick}
      sx={{
        position: "absolute",
        top: "50%",
        left: "-40px",
        transform: "translateY(-50%)",
        width: "25px",
        height: { xs: "50px", sm: "80px", md: "110px", lg: "115", xl: "120px" }, // Responsive height for mobile, tablet, and desktop
        backgroundColor: "#1976d2",
        borderRadius: "10px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        zIndex: 10,
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.8)",
        },
      }}
    >
      <ArrowBackIosIcon
        sx={{ color: "#fff", fontSize: "18px", marginLeft: "7px" }}
      />
    </Box>
  );

  // // Animation Video
  useEffect(() => {
    const savedAnimationId = localStorage.getItem("selectedAnimationId");
    const savedSystemId = localStorage.getItem("selectedSystemId");

    if (savedAnimationId && savedSystemId) {
      const landingPayload = {
        systemId: JSON.stringify(savedSystemId),
        animationId: JSON.stringify(savedAnimationId),
      };
      const fetchData = async () => {
        try {
          const response = await axiosInstance.post(
            API_BASE_URL + "animation/landing",
            landingPayload
          );
          if (response.status >= 200 && response.status <= 300) {

            setIsAnimationVideo(response.data.data[0]);
          } else {
            console.log("Error");
          }
        } catch (err) {
          console.log("Error", err);
        }
      };
      fetchData();
    } else if (isAnimationId && !savedAnimationId && !savedSystemId) {


      const landingPayload = {
        systemId: JSON.stringify(isSystemNumber),
        animationId: JSON.stringify(isAnimationId),
      };
      const fetchData = async () => {
        try {
          const response = await axiosInstance.post(
            API_BASE_URL + "animation/landing",
            landingPayload
          );
          if (response.status >= 200 && response.status <= 300) {
            setIsAnimationVideo(response.data.data[0]);

          } else {
            console.log("Error");
          }
        } catch (error) {
          const errCode = error as AxiosError<{ status: number }>;
          if (errCode.response && errCode.response.status === 401) {
            setIsRestrictionOpen(true);
          } else {
            toast.error("Something went wrong", {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
            });
          }
          throw error;
        }
      };
      fetchData(); // Passing the payload as an argument
    } else {
    }
  }, [isAnimationId]); // Empty dependency array ensures it runs only once on page load

  // Animation Description Content
  useEffect(() => {
    const savedAnimationId = localStorage.getItem("selectedAnimationId");
    const savedSystemId = localStorage.getItem("selectedSystemId");

    if (savedAnimationId && savedSystemId) {
      const payload = {
        animationId: JSON.stringify(savedAnimationId),
      };
      const fetchData = async () => {
        try {
          const response = await axiosInstance.post(
            API_BASE_URL + "animation/animation-description",
            payload
          );
          if (response.status >= 200 && response.status <= 300) {

            const animationArray = response.data.data;
            if (Array.isArray(animationArray) && animationArray.length > 0) {
              const animationContent = animationArray[0]; // Extract the first object
              setIsAnimContent(animationContent);
            } else {
              setIsAnimContent(null);

            }
          } else {
            console.log("Error");
          }
        } catch (err) {
          console.log("Error", err);
        }
      };
      fetchData();
    } else if (isAnimationId && !savedAnimationId && !savedSystemId) {
      const payload = {
        animationId: JSON.stringify(isAnimationId),
      };
      const fetchData = async () => {
        try {
          const response = await axiosInstance.post(
            API_BASE_URL + "animation/animation-description",
            payload
          );
          if (response.status >= 200 && response.status <= 300) {

            const animationArray = response.data.data;
            if (Array.isArray(animationArray) && animationArray.length > 0) {
              const animationContent = animationArray[0]; // Extract the first object
              setIsAnimContent(animationContent);
            } else {
              setIsAnimContent(null);

            }
          } else {
            console.log("Error");
          }
        } catch (error) {
          const errCode = error as AxiosError<{ status: number }>;
          if (errCode.response && errCode.response.status === 401) {
            setIsRestrictionOpen(true);
          } else {
            toast.error("Something went wrong", {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
            });
          }
          throw error;
        }
      };
      fetchData(); // Passing the payload as an argument
    } else {
    }
    setSliderValue(100);
  }, [isAnimationId]); // Empty dependency array ensures it runs only once on page load

  useEffect(() => {
    // Force slider to initial value on video start
    setSliderValue(100);
  }, [isAnimationVideo]); // Reset slider on new video

  // Animation Description Content
  useEffect(() => {
    const savedAnimationId = localStorage.getItem("selectedAnimationId");
    const savedSystemId = localStorage.getItem("selectedSystemId");

    if (savedAnimationId && savedSystemId) {
      const payload = {
        animationId: JSON.stringify(savedAnimationId),
      };
      const fetchData = async () => {
        try {
          const response = await axiosInstance.post(
            API_BASE_URL + "animation/animation-description",
            payload
          );
          if (response.status >= 200 && response.status <= 300) {

            const animationArray = response.data.data;
            if (Array.isArray(animationArray) && animationArray.length > 0) {
              const animationContent = animationArray[0]; // Extract the first object
              setIsAnimContent(animationContent);
            } else {
              setIsAnimContent(null);

            }
          } else {
            console.log("Error");
          }
        } catch (err) {
          console.log("Error", err);
        }
      };
      fetchData();
    } else if (isAnimationId && !savedAnimationId && !savedSystemId) {
      const payload = {
        animationId: JSON.stringify(isAnimationId),
      };
      const fetchData = async () => {
        try {
          const response = await axiosInstance.post(
            API_BASE_URL + "animation/animation-description",
            payload
          );
          if (response.status >= 200 && response.status <= 300) {
            const animationArray = response.data.data;
            if (Array.isArray(animationArray) && animationArray.length > 0) {
              const animationContent = animationArray[0]; // Extract the first object
              setIsAnimContent(animationContent);
            } else {
              setIsAnimContent(null);

            }
          } else {
            console.log("Error");
          }
        } catch (err) {
          console.log("Error", err);
        }
      };
      fetchData(); // Passing the payload as an argument
    } else {
      console.log("empty");
    }
  }, [isActive]); // Empty dependency array ensures it runs only once on page load


  const sliderSettings = {
    infinite: true,
    speed: 2000,
    slidesToShow: 6, // Default for larger screens
    slidesToScroll: 6,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    ref: (slider: any) => (sliderRef.current = slider),

    responsive: [
      {
        breakpoint: 1536, // Large screens (lg)
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1, // Move 4 slides per click
        },
      },
      {
        breakpoint: 1200, // Medium screens (md)
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1, // Move 4 slides per click
        },
      },
      {
        breakpoint: 900, // Small screens (sm)
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1, // Move 2 slides per click
        },
      },
      {
        breakpoint: 600, // Extra small screens (xs)
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1, // Move 1 slide per click
        },
      },
    ],
  };

  const setChooseVideo = (id: number, index: number) => {
    setActiveAnim(id);
    setActiveAnimIndex(id);
    isSetSelectVideo(index);
    setIsActive(id);
    setAnimationId(id);
    localStorage.removeItem("currentAnimId"); // If stored in localStorage
    localStorage.removeItem("currentSystemId"); // If stored in localStorage
    localStorage.setItem("selectedAnimationId",id.toString());
    localStorage.setItem("isPlaying", "true")
  };


  const handleClose = () => {
    isSetOpenModal(false);
  };

  const sliderRef = useRef<any>(null);

  useEffect(() => {
    if (
      sliderRef.current &&
      actIndex !== null &&
      sortedAnimationList.length > 1
    ) {
      const activeIndex = sortedAnimationList.findIndex(
        (item) => item.animationId === actIndex
      );

      if (activeIndex !== -1) {
        setTimeout(() => {
          sliderRef.current.slickGoTo(activeIndex);
        }, 200);
      }
    }
  }, [actIndex, sortedAnimationList]);


  const videoPlayerRef = useRef<MediaPlayerInstance | null>(null);

  useEffect(() => {
    const videoPlayer = videoPlayerRef.current;

    if (videoPlayer) {
      if (playing) {
        videoPlayer.play().catch((err: any) => {
          console.error(`Error playing video: ${err.message}`);
          setVideoIsPlay(true);
        });
      } else {
        videoPlayer.pause();
      }
    }
  }, [playing]);

  const updateVideoSize = () => {
    const videoElement = document.getElementById(
      `videoslider${isAnimationVideo?.animationId}`
    );

    if (videoElement) {
      setVideoSize({
        width: videoElement.clientWidth,
        height: videoElement.clientHeight,
      });
    }
  };

  useEffect(() => {
    const videoElement = document.getElementById(
      `videoslider${isAnimationVideo?.animationId}`
    );

    if (!videoElement) return;

    const updateSize = (entries: ResizeObserverEntry[]) => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;

        setVideoSize((prevSize) => {
          if (prevSize.width !== width || prevSize.height !== height) {
            return { width, height }; //  Update only if different
          }
          return prevSize; //  No update if same
        });
      }
    };

    // Debounce the function to avoid too many updates
    const debouncedUpdateSize = debounce(updateSize, 100);

    const observer = new ResizeObserver(debouncedUpdateSize);
    observer.observe(videoElement);

    window.addEventListener("resize", updateVideoSize);


    return () => {
      observer.disconnect();
      window.removeEventListener("resize", updateVideoSize);
      debouncedUpdateSize.cancel(); // Clean up debounce
    };
  }, [isAnimationVideo?.animationId]);

  const handleVideoPlay = () => {
    if (!isAnimationVideo?.animationId) return; // Ensure video ID exists

    const videoIdString = String(isAnimationVideo.animationId); // Convert to string

    if (!hasPlayedOnce.current || currentVideoId.current !== videoIdString) {
      hasPlayedOnce.current = true;
      currentVideoId.current = videoIdString; // Store as string
      fetchUsageVideoData(videoIdString); // Execute API call
    }
  };

  const fetchUsageVideoData = async (videoId: string) => {
    try {
      const requestData = {
        animationId: parseInt(videoId),
        trackType: "website",
      };

      const response = await axiosInstance.post(
        API_BASE_URL + "animation-viewed/add",
        requestData,
        { loadingTime: null } // Custom loading time
      );
      if (response.status >= 200 && response.status <= 300) {
        // let response_data = response.data.data;
      } else {
        console.log("Error");
      }
    } catch (err) {
      console.log("Error", err);
    }
  };

  return (
    <div style={{ paddingTop: "5px" }}>
      {viewType === "display" ? (
        <div className="AfterLogin">
          <Grid container columnSpacing={2}>
            <Grid
              item
              sm={12}
              md={7}
              lg={7}
              xl={6.5}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Grid item md={12}>
                <Box sx={{ borderRadius: "10px" }}>

                  <MediaPlayer
                    ref={videoPlayerRef}
                    key={isAnimationVideo?.animationTagName}
                    id={`videoslider${isAnimationVideo?.animationId}`}
                    data-vds-id={VIDEO_BASE_URL}
                    className={`carouselvideo${isAnimationVideo?.videoUrl}`}
                    src={VIDEO_BASE_URL + isAnimationVideo?.videoUrl}
                    viewType="video"
                    streamType="on-demand"
                    logLevel="warn"
                    crossOrigin
                    autoPlay={playing}
                    playsInline
                    controls={false}
                    title={
                      isAnimationVideo?.animationTagName
                        ? t(isAnimationVideo?.animationTagName)
                        : ""
                    }
                    poster={isAnimationVideo?.bannerUrl}
                    style={{ height: "100%", borderRadius: "10px" }}
                    // onPlay={() => console.log("Video Playing")}
                    onPlay={handleVideoPlay} //  Executes API once per video
                    onError={() => console.log("Video Error")}
                    onControlsChange={(visible) => setControlsVisible(visible)}
                    hideControlsOnMouseLeave={false}
                  >
                    <MediaProvider>
                      <Poster className="vds-poster" />
                    </MediaProvider>
                    {/* Quality Selector UI */}
                    {controlsVisible && (
                      <div
                        style={{
                          position: "absolute",
                          bottom: "8px",
                          right: "185px",
                          zIndex: 1000,
                        }}
                      >
                        <QualitySelector />
                      </div>
                    )}
                    <DefaultVideoLayout icons={customLayoutIcons} />
                  </MediaPlayer>
                </Box>
              </Grid>
            </Grid>

            <Grid item sm={12} md={5} lg={5} xl={5.5}>
              <Box
                ref={boxRef}
                className="animation-content"
                sx={{
                  boxShadow: 3,
                  borderRadius: "10px",
                  position: "relative",
                  width: "100%",
                  maxWidth: "100%",
                  overflowY: "auto", // Enables scrolling only when content overflows
                  paddingRight: { xs: 0.5, lg: 3, xl: 3 },
                  padding: "10px 0px 10px 10px",
                  height: {
                    xs: "40vh",
                    sm: "45vh",
                    md: "48vh",
                    lg: "51.8vh", // Default large size
                    xl: "56.7vh", // Default extra-large size
                  },
                }}
                style={{
                  height: videoSize.height
                    ? `${videoSize.height}px`
                    : undefined, // Override if available
                  transition: "height 0.4s ease-in-out",
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: { xs: 550, sm: 700 },
                    fontSize: { xs: "15px", sm: "22px" },
                    textAlign: "left",
                    marginBottom: "5px",
                    whiteSpace: "normal",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: "vertical",
                    width: "100%",
                    color: "#004F98",
                  }}
                >
                  {isAnimationVideo?.animationTagName
                    ? t(isAnimationVideo.animationTagName)
                    : ""}
                </Typography>
                {
                  isAnimContent && isAnimContent ? (
                    <>
                      <Typography
                        variant="h6"
                        sx={{ fontSize: { xs: "16px", sm: "16px" }, mb: 1 }}
                        component="div"
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html: isAnimContent?.introductionTagName || "",
                          }}
                        />
                      </Typography>
                      {isAnimContent && isAnimContent?.conditionTagName ? (
                        <Box>
                          <Typography
                            variant="h6"
                            mt={2}
                            sx={{
                              mb: 1,
                              color: "#004F98",
                              fontWeight: "bold",
                              fontSize: { xs: "15px", sm: "17px" },
                            }}
                          >
                            Condition
                          </Typography>
                          <Typography
                            variant="h6"
                            sx={{ fontSize: { xs: "16px", sm: "16px" }, mb: 1 }}
                            component="div"
                          >
                            <div
                              dangerouslySetInnerHTML={{
                                __html: isAnimContent?.conditionTagName || "",
                              }}
                            />
                          </Typography>
                        </Box>
                      ) : (
                        ""
                      )}
                      {isAnimContent && isAnimContent?.symptomsTagName ? (
                        <Box>
                          <Typography
                            variant="h6"
                            mt={2}
                            sx={{
                              mb: 0,
                              color: "#004F98",
                              fontWeight: "bold",
                              fontSize: { xs: "15px", sm: "17px" },
                            }}
                          >
                            Symptoms
                          </Typography>
                          <Typography
                            variant="h6"
                            sx={{ fontSize: { xs: "16px", sm: "16px" }, mb: 1 }}
                          // >
                          >
                            <div
                              dangerouslySetInnerHTML={{
                                __html: isAnimContent?.symptomsTagName || "",
                              }}
                            />
                          </Typography>
                        </Box>
                      ) : (
                        ""
                      )}
                      {isAnimContent && isAnimContent?.actionTagName ? (
                        <Box>
                          <Typography
                            variant="h6"
                            mt={2}
                            sx={{
                              mb: 0,
                              color: "#004F98",
                              fontWeight: "bold",
                              fontSize: { xs: "15px", sm: "17px" },
                            }}
                          >
                            Actions
                          </Typography>
                          <Typography
                            variant="h6"
                            sx={{ fontSize: { xs: "16px", sm: "16px" } }}
                          >
                            <div
                              dangerouslySetInnerHTML={{
                                __html: isAnimContent?.actionTagName || "",
                              }}
                            />
                          </Typography>
                        </Box>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    <>
                      <Typography
                        variant="h6"
                        mt={1}
                        sx={{ fontSize: "16px", mb: 1 }}
                      >
                        Our pre-production phase is where the magic begins! This
                        is the time for brainstorming ideas, crafting detailed
                        storyboards, and shaping the overall concept that drives
                        the animation. We dive deep into defining the story,
                        creating intricate 3D models, and establishing the
                        perfect setting and style that resonates with your
                        audience.
                      </Typography>
                      <Typography
                        variant="h6"
                        mt={2}
                        sx={{
                          mb: 0,
                          color: "#004F98",
                          fontWeight: "bold",
                          fontSize: "17px",
                        }}
                      >
                        Crafting the Script: Accuracy Meets Engaging Content
                      </Typography>
                      <Typography variant="h6" sx={{ fontSize: "16px", mb: 1 }}>
                        Once we've fine-tuned your concept together, it's time
                        to bring it to life with a well-crafted script. Our
                        experienced team collaborates closely with your team and
                        with our own in-house medical professionals to ensure
                        everything we communicate is accurate and easy to
                        understand. We work together to ensure the draft script
                        sounds professional yet remains accessible for patients.
                        This script acts as a detailed blueprint, outlining
                        dialogue, voiceovers, actions, and scenes—setting the
                        stage for a captivating production.
                      </Typography>

                      <Typography
                        variant="h6"
                        mt={2}
                        sx={{
                          mb: 0,
                          color: "#004F98",
                          fontWeight: "bold",
                          fontSize: "17px",
                        }}
                      >
                        Storyboarding and Animation Planning: Visualizing the
                        Story
                      </Typography>
                      <Typography variant="h6" sx={{ fontSize: "16px", mb: 1 }}>
                        Storyboarding is a crucial step where we transform our
                        script into a visual narrative. Here, we sketch each
                        scene or compile references to give a clear sense of how
                        the animation will flow. Whether in video format, if
                        models are ready, or still images in documents,
                        storyboarding provides a structured overview that guides
                        our creative journey.
                      </Typography>
                    </>
                  )
                }
              </Box>
            </Grid>
          </Grid>

          <Grid
            container
            sx={
              {
              }
            }
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              className="homepage_slider"
            >
              <div className="slider-container">

                <Slider {...sliderSettings}>
                  {sortedAnimationList &&
                    sortedAnimationList.map(
                      (image, index) =>
                        image.videoUrl &&
                        image.bannerUrl && (
                          <Box
                            key={index}
                            sx={{
                              padding: {
                                xs: "2px",
                                sm: "8px",
                                md: "6px",
                                lg: "10px",
                                xl: "8px",
                              },
                              maxWidth: "100%",
                              borderRadius: 6,
                              border:
                                actIndex === image.animationId
                                  ? "3px solid #007bff"
                                  : "transparent",
                            }}
                          >
                            <Box
                              onClick={() => {
                                setChooseVideo(image.animationId, index);
                              }}
                              sx={{
                                position: "relative",
                                width: "100%",
                                maxWidth: "100%",
                                top: { xs: 0 },
                                borderRadius: { xs: 4, sm: 6 },
                                overflow: "hidden",
                                cursor: "pointer",
                                transition: "transform 0.3s ease-in-out",
                                margin: "0 auto",
                                boxSizing: "border-box",
                                "&:hover": {
                                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                },
                              }}
                            >
                              {/* Image */}
                              <Box
                                sx={{
                                  position: "relative",
                                  width: "100%",
                                  height: "auto",
                                }}
                              >
                                <Box
                                  component="img"
                                  src={image.bannerUrl}
                                  alt={`Slide ${index + 1}`}
                                  sx={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    backgroundColor: "#2b2b2bde",
                                  }}
                                />

                                {/* Overlay */}
                                <Box
                                  sx={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    backgroundColor: "#2b2b2bde",
                                    opacity: 0.5,
                                    width: "100%",
                                    height: "100%", // Ensures full coverage
                                  }}
                                />
                              </Box>

                              {/* Play Button and Tag */}
                              <Box
                                sx={{
                                  position: "absolute",
                                  bottom: { xs: 0, sm: 0, md: 0 },
                                  left: { xs: 0, sm: 0, md: 0 },
                                  display: "flex",
                                  flexDirection: "row",
                                  alignItems: "center",
                                  backgroundColor: "#00000061",
                                  width: "100%",
                                  padding: "10px 15px",
                                  gap: "8px",
                                }}
                              >
                                {/* Play Button */}
                                <Box
                                  sx={{
                                    width: { xs: 20, sm: 25, md: 30 },
                                    height: { xs: 20, sm: 25, md: 30 },
                                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                                    borderRadius: "50%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
                                    "&:hover": {
                                      backgroundColor: "rgba(255, 255, 255, 1)",
                                    },
                                  }}
                                  onClick={() =>
                                    setChooseVideo(image.animationId, index)
                                  }
                                >
                                  <PlayArrowIcon
                                    sx={{
                                      fontSize: { xs: 18, sm: 22, md: 26 },
                                      color: "#444",
                                    }}
                                  />
                                </Box>
                                <Box>
                                  {/* Tag Text */}
                                  <Typography
                                    variant="caption"
                                    sx={{
                                      fontSize: {
                                        xs: "14px",
                                        sm: "14px",
                                        md: "14px",
                                      },
                                      color: "#fff",
                                      textShadow:
                                        "0 1px 2px rgba(0, 0, 0, 0.6)",
                                      textAlign: "left",
                                      whiteSpace: "normal",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      display: "-webkit-box",
                                      WebkitLineClamp: 2, // Limit to 2 lines
                                      WebkitBoxOrient: "vertical",
                                      maxWidth: "100%",
                                    }}
                                  >
                                    {t(image.animationTagName).length > 40
                                      ? t(image.animationTagName).substring(
                                        0,
                                        40
                                      ) + "..."
                                      : t(image.animationTagName)}
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        )
                      //for Video URL is avail only show video
                    )}
                </Slider>
              </div>

            </Grid>

          </Grid>
        </div>
      ) : (
        <Typography
          variant="h6"
          sx={{ textAlign: "center", marginTop: "20px" }}
        >
          Display View is currently empty.
        </Typography>
      )}
      <Modal
        open={isOpenModal}
        onClose={handleClose}
        className="modal_main"
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Grid
          className="modal_popup"
          container
          justifyContent="center"
          alignItems="center"
        >
          <MediaPlayer
            key={isAnimationVideo?.animationId}
            id={`videoslider${isAnimationVideo?.animationId}`}
            className="carouselvideo"
            src={VIDEO_BASE_URL + isAnimationVideo?.videoUrl}
            viewType="video"
            streamType="on-demand"
            logLevel="warn"
            crossOrigin
            autoPlay
            playsInline
            controls={false}
            title={isAnimationVideo?.animationTagName}
            poster={isAnimationVideo?.bannerUrl}
          >
            <MediaProvider>
              <Poster className="vds-poster" />
            </MediaProvider>
            <DefaultVideoLayout icons={defaultLayoutIcons} />
          </MediaPlayer>
        </Grid>
      </Modal>
      <LoginRestriction open={isRestrictionOpen} />
    </div>
  );
};

export default HomepageAnimation;
